import $ from 'jquery'

$(document).ready(dhsv_vc_link_list())

function dhsv_vc_link_list() {}
